module.exports = "/_next/static/images/phone-5e53ab78878cae13e9221d156a0737fa.png";